/**
 * List of events used by choice-list
 *
 */
export const choiceList = {
  CHOICE_LIST_VALIDATION_ERROR: 'ChoiceList.ValidationError'
}
